import React, { useEffect } from 'react';
import { toast } from 'react-toastify';

import { Modal } from 'antd';

import { DEPOIMENTUS_URL } from 'settings';
import { useGetProductReviewCollector } from 'v2/hooks/useGetProductReviewCollector';

interface ProductReviewProps {
  invoice: { invoice_id: number; customer: { name: string; email: string } };
  product: { id: number; title: string };
  open: boolean;
  onClose: () => void;
  handleReloadProducts: () => void;
}

export default function ProductReview({ invoice, open, onClose, handleReloadProducts, product }: ProductReviewProps) {
  const {
    data: reviewCollector,
    isLoading: isLoadingReviewCollector,
    isError: isErrorReviewCollector
  } = useGetProductReviewCollector(product.id);

  function setUnprocessedReview(review: {
    invoiceId: number;
    productId: number;
    rating: number;
    comment: string | null;
  }) {
    const unprocessedReviews = JSON.parse(localStorage.getItem('unprocessed-reviews')) || [];

    unprocessedReviews.push(review);

    localStorage.setItem('unprocessed-reviews', JSON.stringify(unprocessedReviews));
  }

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.origin !== DEPOIMENTUS_URL) {
        return;
      }

      if (event.data.event === 'processFinished') {
        const { feedback } = event.data;

        setUnprocessedReview({
          invoiceId: invoice.invoice_id,
          productId: product.id,
          rating: feedback.score,
          comment: feedback.content
        });

        handleReloadProducts();
        toast.success('Produto avaliado com sucesso!');
        onClose();
      }
    };

    window.addEventListener('message', handleMessage, false);

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [open, onClose, handleReloadProducts, invoice.invoice_id, product.id]);

  if (isLoadingReviewCollector || isErrorReviewCollector) {
    return null;
  }

  const collectorUrl = new URL(`${DEPOIMENTUS_URL}/c/${reviewCollector.id}`);
  collectorUrl.searchParams.append('name', invoice.customer.name);
  collectorUrl.searchParams.append('email', invoice.customer.email);
  collectorUrl.searchParams.append('trackId', String(invoice.invoice_id));

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      width={600}
      title={<span className='text-lg font-bold'>{product.title}</span>}
      destroyOnClose
    >
      <iframe className='h-150 w-full border-none' src={collectorUrl.toString()} />
    </Modal>
  );
}
